import React from 'react'
import { useNavigate } from 'react-router-dom';

import imageOne from '../../resource/donations/sanghafound/2.png'
import imageFour from '../../resource/donations/sanghafound/3.png'
import imageFive from '../../resource/donations/sanghafound/4.png'
import imageThree from '../../resource/donations/sanghafound/1.png'
import imageSix from '../../resource/donations/sanghafound/5 (2).png'
import TitleChnage from '../../Hook/TitleChnage'

const SangaFound = () => {
    TitleChnage("Sangha Fund")
    const navigate = useNavigate();
                
                    const handleClick = (event) => {
                
                        const pathMap = {
                            sanghaFundReq : '/sanghaFundReq',
                        }
                    
                        const path = event.currentTarget.id;
                        const targetPath = pathMap[path]
                    
                        if (targetPath){
                          navigate(targetPath)
                        }
                      }
  return (
    <div className="sanghafound-page inside-pages">
    <div className="right-box">
        <img src={imageOne} alt="Right Top Image" className="right-image" width={300} />
    </div>

    <h1 className='font-main p-4 mt-4'>Sangha Fund</h1>

    <div className="text-center mt-6 h4-bold">
        <div>
            <p >Gone forth to be in freedom,</p>
            <p >Sangha, the savior, our guardian,</p>
            <p >Protecting the Sasana, merits grown,</p>
            <p >Gaining strength, you are divine.</p>


        </div>
    </div>
    <p className="mt-6 h4 p-4">Bhaddeka Vihari Monastery and Meditation Centre is honored to regularly invite esteemed members of the Sangha from overseas to stay at the Monastery. During their visit, special retreats, Dhamma talks, and discussions are held to spread the Buddha’s teachings and inspire spiritual growth within the community</p>
    <p className="mt-5 h4 p-4">Additionally, senior members of the Sri Kalyana Yogashrama Samsthawa, Sri Lanka also visit the Monastery, offering their valuable guidance to spread the Dhamma not only within the Monastery but throughout Australia. Their presence is a great blessing, enriching both the local community and the overall environment of the Monastery. </p>
    <p className="mt-5 h4 p-4">The Sangha Fund has been established to assist with the travel expenses of these esteemed monastics, including their Australian visa and visa extensions, travel & medical insurances, and other related costs including domestic accommodations and travels. Your generous donations will help ensure that the Sangha can continue their important work of sharing the Dhamma and strengthening the practice of Buddhism within our community.</p>
    <p className=" h4 p-4">If you wish to make a monetary donation, please use the available payment option.</p>

    <p className="mt-5 h4 p-4">Your contribution to the Sangha Fund supports the noble efforts of these revered monastics, helping to ensure the spread of the Dhamma and the continued growth of the spiritual community.</p>
    <p className="mt-5 h4 p-4">We are deeply grateful for your support.</p>

   

    <div className='btn-group2 mt-6'>
        <img src={imageFour} alt="Right Top Image" width={300} />
        <img src={imageFive} alt="Right Top Image" width={300} />
    </div>


    <div className="p-4 mt-6 text-center">
    <div className="mt-6 calander-box align-item-center">
            <div className="c-details text-left">
                <h2 className='intro-text '>Futher More Details : </h2>
                <p className="font-p mt-4">Monastery : 035608 0918 / 0459 729 738</p>
                <p className="font-p">Mr Gamini : 0422 069 359</p>
                <p className="font-p">WhatsApp : 0422 069 359</p>
                <p className="font-p">E-mail : info@bvp.org.au</p>
            </div>
            <div className="d-button">
                  <img
          src={imageSix}
          alt="Right Top Image"
          width={300}
          id="sanghaFundReq"
         onClick={handleClick}
          className="curser-pointer"
        />
                    </div>
        </div>
        </div>

        <div className="bottom-box mt-6">
        <img src={imageThree} alt="bottom-image"  width={600} />
    </div>

</div>
  )
}

export default SangaFound